module.exports = __webpack_public_path__ + "img/shui.f2bfa717.png";